import { detect } from 'detect-browser';

const browser = detect();

if (browser) {
  const classes = [
    browser.name.replaceAll(' ', '-'),
    `${browser.name}-${browser.version}`.replaceAll(' ', '-'),
    `${browser.name}-${browser.os}`.replaceAll(' ', '-'),
  ];

  document.querySelector('html').classList.add(...classes);
}

if (['ios', 'crios'].includes(browser.name)) {
  document.addEventListener('touchstart', function () {}, false);
}

new ResizeObserver(() => {
  const vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}).observe(document.documentElement);
